import { moneyDisplay, qtyDisplay } from "@icraftx/shared/v1";
import {
  formatReceiptIssuedAt,
  type PosReceiptData,
} from "./receipt-math";

export function PosReceipt({ data }: { data: PosReceiptData }) {
  return (
    <article className="pos-receipt font-mono text-[12px] leading-snug text-black">
      <header className="text-center">
        <div className="text-[14px] font-bold tracking-wide">
          {data.companyName}
        </div>
        <div className="mt-0.5 text-[11px]">{data.terminalName}</div>
        <div className="mt-2 font-bold">{data.number}</div>
        {data.provisional && (
          <div className="text-[10px]">Local — sync will confirm number</div>
        )}
        <div className="mt-1 text-[10px]">
          {formatReceiptIssuedAt(data.issuedAt)}
        </div>
      </header>

      <div className="my-3 border-t border-dashed border-black/40" />

      <ul className="m-0 list-none space-y-2 p-0">
        {data.lines.map((line, i) => (
          <li key={`${line.name}-${i}`}>
            <div className="font-sans text-[12px] font-medium">{line.name}</div>
            <div className="flex justify-between gap-2">
              <span>
                {qtyDisplay(line.qty)} × ₱{moneyDisplay(line.unitPrice)}
              </span>
              <span>₱{moneyDisplay(line.lineTotal)}</span>
            </div>
          </li>
        ))}
      </ul>

      <div className="my-3 border-t border-dashed border-black/40" />

      <div className="space-y-1">
        {data.discountPct && (
          <div className="flex justify-between">
            <span>Discount</span>
            <span>{data.discountPct}%</span>
          </div>
        )}
        <div className="flex justify-between">
          <span>Net</span>
          <span>₱{moneyDisplay(data.netTotal)}</span>
        </div>
        <div className="flex justify-between">
          <span>Tax</span>
          <span>₱{moneyDisplay(data.taxTotal)}</span>
        </div>
        <div className="flex justify-between text-[13px] font-bold">
          <span>
            {data.taxPriceMode === "inclusive" ? "Total (incl. tax)" : "Total"}
          </span>
          <span>₱{moneyDisplay(data.grossTotal)}</span>
        </div>
        <div className="flex justify-between">
          <span>{data.payMethodName}</span>
          <span>₱{moneyDisplay(data.tenderAmount)}</span>
        </div>
        <div className="flex justify-between">
          <span>Change</span>
          <span>₱{moneyDisplay(data.changeGiven)}</span>
        </div>
      </div>

      <footer className="mt-4 text-center text-[10px]">
        Thank you · {data.currencyCode}
      </footer>
    </article>
  );
}

export function printPosReceipt(): void {
  window.print();
}
